import LearningAdminModuleCategoryModal from '../components/LearningAdminModuleCategoryModal';
import { deleteModuleCategoryAdmin } from '../../../../../state/modules/learningsAdmin/actions';
import storage from '../../../../../lib/Storage';
import { connect } from 'react-redux';
import { findStorageType } from '../../../../../lib/Auth';

const mapStateToProps = (state, ownProps) => {
  return {
    partnershipId: storage.get(findStorageType(), 'partnershipId'),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    remove: (partnershipId, id, cb) => {
      dispatch(deleteModuleCategoryAdmin(partnershipId, id, cb));
    },
  };
};

const LearningAdminModuleCategoryModalContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(LearningAdminModuleCategoryModal);

export default LearningAdminModuleCategoryModalContainer;
